export default __webpack_public_path__ + "static/media/offing-mahreen-sohail.29196bb2.webp";